<mat-toolbar class="panel-toolbar">
  <button
    mat-raised-button
    color="primary"
    (click)="onSave()"
    [disabled]="saving"
  >
    {{ label('Guardar', 'Guardar') }}
  </button>
  <button
    *ngIf="showActivarTodosButton"
    mat-raised-button
    class="btn-activar-todos"
    (click)="toggleActivarDesactivarTodos()"
  >
    {{ activarTodosButtonLabel }}
  </button>
  <span class="spacer"></span>
  <span class="dialog-title">{{ label('PermisosDelModulo', 'Permisos del módulo') }}: {{ aplicacion?.NombreAplicacion || '' }} – {{ moduloPrincipal?.NombreModulo || '' }}</span>
  <span class="spacer"></span>
  <button mat-icon-button (click)="onCancel()" [attr.aria-label]="label('Cerrar', 'Cerrar')">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<div class="form-body" *ngIf="hasData && aplicacion">
  <div class="permisos-sections">
    <mat-card class="aplicacion-card">
      <div class="section-title">{{ moduloPrincipal?.NombreModulo }}</div>
      <div class="modulos-list">
        <!-- Módulo principal: Ver primeiro (em destaque), depois as demais ações -->
        <div class="modulo-block" *ngIf="moduloPrincipal">
          <ng-container *ngIf="getAccionVer(moduloPrincipal) as accVer">
            <div class="ver-block">
              <mat-slide-toggle
                class="ver-toggle"
                [checked]="isAccionActivo(accVer)"
                [disabled]="isToggleDisabled(moduloPrincipal, accVer)"
                (change)="onAccionChange(aplicacion, moduloPrincipal, accVer, $event.checked)"
              >
                {{ labelAccion(accVer.NombreAccion) }}
              </mat-slide-toggle>
              <span class="ver-hint">{{ getVerHint(moduloPrincipal) }}</span>
            </div>
            <div class="acciones-resto-wrap" *ngIf="getAccionesResto(moduloPrincipal).length">
              <div class="acciones-resto-title">{{ label('OtrasAcciones', 'Otras acciones') }}</div>
              <div class="acciones-grid" [class.acciones-grid-dense]="getAccionesResto(moduloPrincipal).length > 8">
                <mat-slide-toggle
                  *ngFor="let acc of getAccionesResto(moduloPrincipal)"
                  [checked]="isAccionActivo(acc)"
                  [disabled]="isToggleDisabled(moduloPrincipal, acc)"
                  (change)="onAccionChange(aplicacion, moduloPrincipal, acc, $event.checked)"
                >
                  {{ labelAccion(acc.NombreAccion) }}
                </mat-slide-toggle>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!getAccionVer(moduloPrincipal) && getAccionesParaMostrar(moduloPrincipal).length">
            <div class="ver-block" *ngIf="accionPadre">
              <mat-slide-toggle
                class="ver-toggle"
                [checked]="isAccionActivo(accionPadre)"
                [disabled]="isToggleDisabled(moduloPrincipal, accionPadre)"
                (change)="onAccionChange(aplicacion, moduloPrincipal, accionPadre, $event.checked)"
              >
                {{ labelAccion(accionPadre.NombreAccion) }}
              </mat-slide-toggle>
              <span class="ver-hint">{{ getPadreHint() }}</span>
            </div>
            <div class="acciones-grid" [class.acciones-grid-dense]="getAccionesSinPadre(moduloPrincipal).length > 8" *ngIf="getAccionesSinPadre(moduloPrincipal).length">
              <mat-slide-toggle
                *ngFor="let acc of getAccionesSinPadre(moduloPrincipal)"
                [checked]="isAccionActivo(acc)"
                [disabled]="isToggleDisabled(moduloPrincipal, acc)"
                (change)="onAccionChange(aplicacion, moduloPrincipal, acc, $event.checked)"
              >
                {{ labelAccion(acc.NombreAccion) }}
              </mat-slide-toggle>
            </div>
          </ng-container>
        </div>

        <!-- Submódulos em modo sanfona (accordion), para evitar listas enormes -->
        <div class="modulo-block submodulos-wrap" *ngIf="moduloPrincipal && submodulos.length > 0">
          <div class="section-title section-title-sub">{{ label('Submodulos', 'Submódulos') }}</div>
          <div class="submodulos">
            <mat-accordion class="submodulos-accordion">
              <mat-expansion-panel
                *ngFor="let sub of submodulos; let i = index"
                class="submodulo-panel"
                [expanded]="submodulos.length === 1"
                (opened)="onSubmoduloOpened(subHeader)"
              >
                <mat-expansion-panel-header #subHeader>
                  <mat-panel-title>
                    {{ sub.NombreModulo }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{ getActiveAccionesCount(sub) }}/{{ getTotalAccionesCount(sub) }}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div #subContent class="submodulo-card">
                  <ng-container *ngIf="getAccionVer(sub) as accVer">
                    <div class="ver-block">
                      <mat-slide-toggle
                        class="ver-toggle"
                        [checked]="isAccionActivo(accVer)"
                        [disabled]="isToggleDisabled(sub, accVer)"
                        (change)="onAccionChange(aplicacion, sub, accVer, $event.checked)"
                      >
                        {{ labelAccion(accVer.NombreAccion) }}
                      </mat-slide-toggle>
                      <span class="ver-hint">{{ getVerHint(sub) }}</span>
                    </div>
                    <div class="acciones-resto-wrap" *ngIf="getAccionesResto(sub).length">
                      <div class="acciones-resto-title">{{ label('OtrasAcciones', 'Otras acciones') }}</div>
                      <div class="acciones-grid" [class.acciones-grid-dense]="getAccionesResto(sub).length > 8">
                        <mat-slide-toggle
                          *ngFor="let acc of getAccionesResto(sub)"
                          [checked]="isAccionActivo(acc)"
                          [disabled]="isToggleDisabled(sub, acc)"
                          (change)="onAccionChange(aplicacion, sub, acc, $event.checked)"
                        >
                          {{ labelAccion(acc.NombreAccion) }}
                        </mat-slide-toggle>
                      </div>
                    </div>
                  </ng-container>
                  <div class="acciones-grid" [class.acciones-grid-dense]="getAccionesParaMostrar(sub).length > 8" *ngIf="!getAccionVer(sub) && getAccionesParaMostrar(sub).length">
                    <mat-slide-toggle
                      *ngFor="let acc of getAccionesParaMostrar(sub)"
                      [checked]="isAccionActivo(acc)"
                      [disabled]="isToggleDisabled(sub, acc)"
                      (change)="onAccionChange(aplicacion, sub, acc, $event.checked)"
                    >
                      {{ labelAccion(acc.NombreAccion) }}
                    </mat-slide-toggle>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>

<div *ngIf="!hasData" class="no-data">
  {{ label('NoSeEncontraronDatos', 'No se encontraron datos') }}
</div>
